import { useEffect, useState } from "react";
import loadingIcon from "../../assests/page/payment-loading-icon.svg";
import { debounce } from "lodash";
import { motion } from "framer-motion";

const PaymentProcess = (props) => {
  const [showReceipt, setShowReceipt] = useState(false);
  const [time, setTime] = useState(Number(props.time) || 15);

  useEffect(() => {
    if (time === 0) return;

    const reduceTime = setInterval(() => {
      setTime((prevCountdown) => prevCountdown - 1);
    }, 1000);

    return () => clearInterval(reduceTime);
  }, [time]);

  return (
    <div
      style={
        props.mobileScreen
          ? {
              alignContent: "center",
              justifyContent: "center",
              width: "100%",
            }
          : {}
      }
      className="add-funds-popup"
    >
      {showReceipt && (
        <div className="add-funds-content">
          <div className="add-funds-content-header"></div>
          <div className="payments-popup-content-footer"></div>
        </div>
      )}
      {!showReceipt && (
        <div className="paymment-processing-popup-content">
          <div className="paymment-processing-popup-content-container">
            <motion.img
              height="47px"
              width="47px"
              src={loadingIcon}
              alt="Loading Icon..."
              animate={{
                rotate: 360,
                scale: [1, 1, 1],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "linear",
              }}
            />

            <div className="paymment-processing-popup-content-header">
              <p className="paymment-processing-popup-content-header-text">
                {props.title ? props.title : "Processing Payment..."}
              </p>
              <p className="paymment-processing-popup-content-footer-text">
                {props.description
                  ? props.description
                  : "This won’t take more than"}{" "}
                <span className="paymment-processing-popup-content-footer-text-footer">
                  {time}s
                </span>
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentProcess;
